export enum SuggestionStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    PROCESSED = 'PROCESSED',
    REJECTED = 'REJECTED'
}